module.exports = __webpack_public_path__ + "static/media/loading.1753a708.gif";